var MuiDivider = {
    root: {
        backgroundColor: 'currentColor',
        opacity: 0.5,
    },
    light: {
        backgroundColor: 'currentColor',
        opacity: 0.25,
    },
};
export default MuiDivider;
//# sourceMappingURL=MuiDivider.js.map